import * as Swiper from 'swiper';

import {BaseComponent} from '@pixelart/component-handler';
import 'swiper/dist/css/swiper.css';

export class HeaderSlider extends BaseComponent {
    protected HEADERSLIDER_SELECTOR: string = '.headerslider__swiper';
    protected BTN_NEXT_SELECTOR: string = '.headerslider__button-next';
    protected BTN_PREV_SELECTOR: string = '.headerslider__button-prev';
    protected PAGINATION_SELECTOR: string = '.headerslider__pagination';
    protected PARALLAX_SELECTOR: string = '.headerslider__parallax';
    protected PARALLAX_BG_SELECTOR: string = '.headerslider__parallax-bg';
    protected PARALLAX_CONTENT_SELECTOR: string = '.headerslider__parallax-content';
    private swiper: Swiper;
    private interleaveOffset: number = 0.25; // keep this value in sync with the margin-left in the css
    private bgPatternOffset: number = -0.25;

    public constructor(element: Element) {
        super(element);
    }

    public init() {
        this.initHeaderSlider();
    }

    public initHeaderSlider() {
        this.swiper = new Swiper(this.HEADERSLIDER_SELECTOR, {
            effect: 'slide',
            loop: true,
            nextButton: this.BTN_NEXT_SELECTOR,
            onProgress: (swiper, progress) => {
                const slides: any = swiper.slides;

                for (const slide of slides) {
                    let innerTranslate;
                    let bgTranslate;
                    progress = slide.progress;

                    if (progress > 0) {
                        innerTranslate = progress * swiper.width * this.interleaveOffset;
                        bgTranslate = progress * swiper.width * this.bgPatternOffset;
                    } else {
                        innerTranslate = Math.abs(progress * swiper.width) * (-1) * this.interleaveOffset;
                        bgTranslate = Math.abs(progress * swiper.width) * this.bgPatternOffset;
                    }

                    $(slide).find(this.PARALLAX_SELECTOR).css({
                        transform: 'translate3d(' + innerTranslate + 'px,0,0)',
                    });
                    $(slide).find(this.PARALLAX_BG_SELECTOR).css({
                        transform: 'translate3d(' + bgTranslate + 'px,0,0)',
                    });
                }
            },
            onSetTransition: (swiper, speed) => {
                for (const slide of swiper.slides) {
                    $(slide)
                        .find(this.PARALLAX_SELECTOR)
                        .css({transition: speed + 'ms'});
                    $(slide)
                        .find(this.PARALLAX_BG_SELECTOR)
                        .css({transition: speed + 'ms'});
                }
            },
            pagination: this.PAGINATION_SELECTOR,
            paginationBulletRender: (swiper: Swiper, index: number, className: string) => {
                return `<span class="${className} headerslider__pagination-bullet" title="${index + 1}"></span>`;
            },
            paginationClickable: true,
            prevButton: this.BTN_PREV_SELECTOR,
            speed: 1200,
            watchSlidesProgress: true,
        });
    }

    public destroy() {
        this.swiper.destroy(true, true);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/headerslider/headerslider.class.ts